import { interpolate, removeFormatter } from "@ssf/components";
import type { Document as DocumentType, Signature } from "@ssf/sign-worker";

import { medlemslappDigital } from "../lib/index.js";
import { Markdown } from "./index.js";

const getSeason = (year: string | number) => ({
  startDate: `${year}-01-01`,
  endDate: `${year}-12-31`,
});

export const Document = ({
  document,
}: {
  document: DocumentType & { signatures: Signature[] };
}) => {
  return document.type === "document" ? (
    <Markdown>{removeFormatter(document.meta.content)}</Markdown>
  ) : (
    <Markdown>
      {removeFormatter(
        interpolate(medlemslappDigital, {
          member: {
            firstname: document.meta.member.name,
            lastname: "",
            ...document.meta.member,
          },
          club: {
            season: getSeason(
              document.signatures[0]?.signedAt?.substring(0, 4) ||
                new Date().getFullYear(),
            ),
            ...document.meta.club,
          },
          timestamp: document.signatures[0]?.signedAt
            ? new Date(document.signatures[0]?.signedAt).toLocaleString("sv-SE")
            : "",
        }),
      )}
    </Markdown>
  );
};
